import { Injectable } from '@angular/core';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { defaultSessionRefreshTime, getLocalStorage } from '../helpers/helper';
// import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutService {
  // private _count: number = 0;
  private _serviceId: string =
    'idleTimeoutSvc-' + Math.floor(Math.random() * 10000);
  // private _timeoutMilliseconds: number = 15000;
  private timerSubscription: Subscription;
  private _timer: Observable<number>;
  /* private resetOnTrigger: boolean = false;
  private lastTime: number;
  private dateTimer: Observable<any>;
  private dateTimerSubscription: Subscription;
  private dateTimerInterval: number = 1000;
  private dateTimerTolerance: number = 1000 * 10; */
  public timeoutExpired: Subject<boolean> = new Subject<boolean>();
  private logout = false;

  constructor() {
    this.timeoutExpired.subscribe(n => {});

    this.startTimer();
  }

  public setLogout(logout: boolean) {
    this.logout = logout;
  }

  private setSubscription() {
    const storedToken = getLocalStorage('token');
    if (!storedToken) {
      return;
    }

    // this._timer = timer(this._timeoutMilliseconds);

    if (this.logout) {
      // this._timer = timer(60000);
      this._timer = timer(30000);
    } else {
      this._timer = timer((defaultSessionRefreshTime(storedToken) + 90) * 1000);
      // this._timer = timer(5000);
    }

    this.timerSubscription = this._timer.subscribe(n => {
      this.timeoutExpired.next(this.logout);
      this.resetTimer();
      // this.halfSessionComplete();
    });
  }

  /* private startDateCompare() {
    this.lastTime = new Date().getTime();
    this.dateTimer = timer(this.dateTimerInterval); // compare every five minutes
    this.dateTimerSubscription = this.dateTimer.subscribe(n => {
      const currentTime: number = new Date().getTime();
      if (
        currentTime >
        this.lastTime + this.dateTimerInterval + this.dateTimerTolerance
      ) {
        // look for 10 sec diff
      } else {
      }
      this.dateTimerSubscription.unsubscribe();
      this.startDateCompare();
    });
  } */

  public startTimer() {
    if (this.timerSubscription) {
      this.stopTimer();
    }

    this.setSubscription();
  }

  public stopTimer() {
    this.timerSubscription.unsubscribe();
  }

  public resetTimer() {
    this.startTimer();
  }

  /* private halfSessionComplete() {
    this.timeoutExpired.next(false);
    if (this.resetOnTrigger) {
      this.startTimer();
    }
  } */
}
